import React from 'react';
import ParallaxSection from './ParallaxSection';
import { useScrollToContact } from '../hooks/useScrollToContact';

const activities = [
  {
    name: 'Segelflug',
    description: 'Erleben Sie die ruhige Eleganz des Segelflugs und segeln Sie durch die Lüfte.',
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 8L2 12l10 4 10-4-10-4z"/>
        <path d="M12 6v12"/>
        <path d="M8 14l-6 2v2l6-2z"/>
        <path d="M16 14l6 2v2l-6-2z"/>
      </svg>
    ),
  },
  {
    name: 'Ultraleichtflug (UL-Flug)',
    description: 'Steuern Sie leichte und wendige Flugzeuge und genießen Sie die Freiheit des Fliegens.',
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
      </svg>
    ),
  },
  {
    name: 'Gastflüge',
    description: 'Buchen Sie einen Gastflug mit unseren erfahrenen Piloten und erleben Sie den Himmel aus erster Hand.',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
];

const Activities: React.FC = () => {
  const scrollToContact = useScrollToContact();

  return (
    <ParallaxSection
      id="aktivitaeten"
      backgroundImage="/images/Flugsportverein_Bilder_2.jpg"
    >
      <div>
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Aktivitäten</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Unsere Angebote
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Ob Anfänger oder Profi – bei uns finden Sie die passende Aktivität. Erleben Sie die Faszination des Fliegens hautnah!
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {activities.map((activity) => (
              <div key={activity.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-blue-600 text-white">
                    {activity.icon}
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{activity.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{activity.description}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-10 text-center">
          <a
            href="#kontakt"
            onClick={scrollToContact}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
          >
            Buchen Sie jetzt Ihren Gastflug!
          </a>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Activities; 